import {getAllUnreadMessages, listChats} from "../API/chatAPI";
import {kbUserDataLoaded, RAW_FILES_URL} from "../utils";
import {getKBImage} from "../KB/KBImage";
import {decryptKBItem} from "./cryptoUtils";
import {playSound, takeTheSoundLock} from "../Media/utils";
import {getQueryParamValue, isMobile} from "./utils";

export const fetchUnreadMessages = ({setUnreadMessages}) => {
    getAllUnreadMessages().then(data => {
        const unreadMessages = {};
        data?.data.forEach(item => unreadMessages[item.chatId] = item.unreadCount);
        setUnreadMessages(unreadMessages);
    })
}
export const createHandleWebsocketMessages = ({
    kbSubdomain, kbData, fetchKBBalances, userProfile, fetchUserBalances, navigateToChat, setKBChats,
    chatId, setPenalty, penalty
}) => {
    return (event) => {
        if (localStorage.getItem('openkbsDisableWebsocket')) return;
        const data = JSON.parse(event.detail);
        const eventName = data?.eventName;
        const NewImage = data?.NewImage;
        const OldImage = data?.OldImage;
        const requestedChatId = data?.NewImage?.chatId || data?.OldImage?.chatId

        const table  = data?.tableName
        if (table === "ledger-account") {
            if (OldImage?.penalty?.level !== NewImage?.penalty?.level) {
                setPenalty(NewImage?.penalty)
            }

            if (kbSubdomain && kbData) {
                fetchKBBalances(kbData);
            } else if (userProfile?.accountId) {
                fetchUserBalances(userProfile);
            }

        } else if (table === "openkb-kb-chats") {
            if (getQueryParamValue('tab')) return;
            // remove current chat
            if (eventName === 'REMOVE' && OldImage?.chatId && requestedChatId === chatId) {
                navigateToChat(null)
                setKBChats(prev => (prev || []).filter(chat => chat.chatId !== OldImage.chatId));
            } else if (eventName === 'INSERT' && NewImage && !chatId) {
                navigateToChat(NewImage?.chatId)
                setKBChats(prev => [...(prev || []), {...NewImage, title: decryptKBItem(NewImage.title)}]);
            } else if (eventName === 'MODIFY' && NewImage && !chatId) {
                navigateToChat(NewImage?.chatId)
                setKBChats(prev => (prev || []).map(chat =>
                    chat.chatId === NewImage.chatId ? {...chat, ...NewImage} : chat
                ));
            } else {
                listChats().then(result => setKBChats(result?.data || []));
            }
        } else if (table === "openkb-chat-messages") {

            if (eventName === 'INSERT' && data?.NewImage) {
                const {content, msgId, role, userId} = data?.NewImage;
                const  userIdWithoutPrefix = userId?.split('_')?.[1]
                const requestedChatId = data?.NewImage?.chatId

                if (!window?.Notification) {
                    console.log("Notification object not found");
                    return;
                }

                const isChatHidden = requestedChatId !== chatId;
                const notificationOn = window?.Notification?.permission === "granted"
                const isMe = userIdWithoutPrefix === kbUserDataLoaded?.myUserId;

                if (isMe) return;

                // message from another member
                if (!isChatHidden && !document.hidden) {
                    takeTheSoundLock();
                    playSound('/static/sound/interface.mp3', 0.15)
                } else if (isChatHidden && !document.hidden) {
                    playSound('/static/sound/happypop.mp3')
                } else if (notificationOn && (isChatHidden || document.hidden)) {
                    // PWA Push Notifications postMessage
                    if (!isMobile) playSound('/static/sound/happypop.mp3')
                    navigator.serviceWorker.ready.then((registration) => {
                        const baseUrl = new URL(window.location.href).origin;
                        const path = `/chat/${encodeURIComponent(requestedChatId)}`;

                        const payload = {
                            icon: userId
                                ? `${RAW_FILES_URL}/user-image/${userId?.split?.('_')?.[1]}.png`
                                : getKBImage(),
                            url: `${baseUrl}${path}`,
                            type: 'SHOW_NOTIFICATION',
                            title: `From: ${role === 'user' ? userId : role} at ${kbData?.kbTitle}`,
                            body: decryptKBItem(content),
                        };

                        registration.active.postMessage(payload);
                    });
                } else if (!notificationOn && (isChatHidden || document.hidden)) {
                    playSound('/static/sound/happypop.mp3')
                }
            }

        }
    };
}

